import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchTrialBalance } from '../query-api'
import { TrialBalanceReportOptions } from '../types/reportOptions'

export const useFetchTrialBalanceReport = (options?: TrialBalanceReportOptions) => {
  const { organization } = useUserOrganization()

  const { data, ...rest } = useQuery(
    [QueryKeys.TrialBalanceLegacy, { organizationId: organization?.id, ...options }],
    () => fetchTrialBalance({ organizationId: organization?.id as string, options }),
    {
      enabled: !!organization?.id && organization.countryId !== 'NL',
      staleTime: defaultStaleTime,
    },
  )

  return { report: data?.report, ...rest }
}
